import { 
  statusCabinetStart,
  statusCabinetSuccess,
  statusCabinetFailure 
} from "./cabinetSlice";

import { get, post, put, remove } from "../../requestMethods"
import { Dispatch } from "react";

export const getCabinetsApi = () => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusCabinetStart())
    const response = await get(`cabinet`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusCabinetSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusCabinetFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusCabinetFailure(errData))
      return [errData]
    }
  }
}

export const AddCabinetApi = (data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusCabinetStart())
    const response = await post(`cabinet`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusCabinetSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusCabinetFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusCabinetFailure(errData))
      return [errData]
    }
  }
}

export const EditCabinetApi = (cabinetId: string, data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusCabinetStart())
    const response = await put(`cabinet/${cabinetId}`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusCabinetSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusCabinetFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusCabinetFailure(errData))
      return [errData]
    }
  }
}

export const DeleteCabinetApi = (cabinetId: string) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusCabinetStart())
    const response = await remove(`cabinet/${cabinetId}`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusCabinetSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusCabinetFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusCabinetFailure(errData))
      return [errData]
    }
  }
}


export const clearCabinetApi = async (dispatch: Dispatch<any>) => {
  dispatch(statusCabinetSuccess([]))
}
